import { GET_FILTER_SECTION } from 'constants/filter-section';

const initialState = {
  isFetching: false,
  data: {},
  error: null,
};

export const filterSectionReducer = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case `${GET_FILTER_SECTION}_PENDING`: {
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    }
    case `${GET_FILTER_SECTION}_FULFILLED`: {
      return {
        ...state,
        isFetching: false,
        data: payload,
        error: null,
      };
    }
    case `${GET_FILTER_SECTION}_REJECTED`: {
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };
    }
    default:
      return state;
  }
};
